//src/assets/scripts/gallery.js

import PageJS from './gallery/page';
import CommonJS from './common';
const common = new CommonJS();
const page = new PageJS(common);
page.init();